.cx{display:inline-flex;}